module.exports = __webpack_public_path__ + "img/vip_baiyin.860d03b8.png";